<ul class="stepper-list" *ngIf="type === 1">
	<li *ngFor="let item of listStepper; let i = index"
		class="stepper-item"	[ngClass]="{'completed': item.completed && indexList[i]}">			
		<a [id]="i" class="stepper-action" (click)="sendStepper.emit(item)">
			<img alt="cool"	src="../../../assets/svgs/{{item.completed ? item.iconLast : item.icon }}">
			<p>{{ item.description }}</p>
		</a>
	</li>
</ul>

<mat-vertical-stepper *ngIf="type === 2" [disableRipple]="true" #stepper (click)="sendData.emit(stepper)">
  <mat-step *ngFor="let item of stepperData; let i = index">
    <ng-template matStepLabel>
      <h3>{{ stepperData[i].title }}</h3>
    </ng-template>
    <ul class="container" >
      <li class="stepper" *ngFor="let item of stepperData[i].listStepper; let i = index" >
        <a class="icon-action" [class.icon-action__completed]="item.active" (click)="sendStepperList.emit(i)">
          <div class="icon-items">
            <svg width="1" height="17" viewBox="0 0 1 17" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="2.95695e-08" x2="0.499999" y2="17" stroke="#C4C4C4" [ngStyle]="{'stroke': item.active ? '#46DCAA' : null }"/>
            </svg>
            <img src="../../../../assets/svgs/{{item.icon}}.svg" alt="Icone">
          </div>
          <p>{{ item.title }}</p>
        </a>
      </li>
    </ul>
  </mat-step>
</mat-vertical-stepper>